<template>
  <a class="btn-top" title="상단으로 이동"
    ><span class="icon" @click="scrollTop"></span>
  </a>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {
    scrollTop() {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    },
  },
};
</script>
